export enum DisplayGroupId {
	bodyPanel,
	bottomPanel,
	columnContainer,
	leftPanel,
	pageContainer,
	rowContainer,
	topPanel,
}

export enum PlaceholdersId {
	accountSelector,
	availableAccountList,
	accountSelected,
	bankDocument,
	bootstrap,
	cloudwareDocument,
	cloudwareDocumentDisclaimer,
	costSummary,
	doubtsAndExit,
	fixedFooter,
	integratedSolutionCard,
	logo,
	membershipCompletionTitle,
	planCards,
	plansComparison,
	promotionalCode,
	serviceError,
	summaryNextSteps,
	wizardMenu,
	authenticatorFooter,
	modals,
	titleDocumentTermsCondition,
	titleResumeAndAuthorization,
	logoBcp,
	requestContact,
	changeEmail,
	enterpriseSolution,
	membershipCompletionEnterpriseSolution,
	introWizard,
	intro,
	personalAccidentInsurance,
	establishmentAssistanceInsurance,
}
